import { useState } from "react";
import { TeamMember } from "../team-member";
import { MemberCard } from "../team-members/team-member-card";
import { LayoutWithTeamExistanceChecker } from "../layout";
import { useTeam } from "../team-members/team-member-context";

type Activity = {
  id: string,
  name: string,
  type: 'continuous' | 'sporadic'
}

type Facilitation = {
  id: string,
  activity: Activity,
  teamMember: TeamMember
}

// https://stackoverflow.com/questions/1527803/generating-random-whole-numbers-in-javascript-in-a-specific-range
function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const activities: Activity[] = [
  {
    id: '1',
    name: "Daily",
    type: "continuous",
  },
  {
    id: '2',
    name: "Retro",
    type: "continuous",
  },
  {
    id: '3',
    name: "Spike results",
    type: "sporadic",
  },
  {
    id: '4',
    name: "General meeting",
    type: "sporadic",
  },
  {
    id: '5',
    name: "Three amigos",
    type: "continuous",
  },
  {
    id: '6',
    name: "Speedback",
    type: "continuous",
  },
];

export function Facilitator() {
  const { teamMembers } = useTeam();
  const [selectedActivity, setSelectedActivity] = useState<Activity>(activities[0]);
  const [selectdFacilitator, setFacilitator] = useState<TeamMember | undefined>();
  const [facilitationsDone, setFacilitationsDone] = useState<Facilitation[]>([]);

  const pickFacilitator = () => {
    const random = getRandomInt(1, teamMembers.length);
    const facilitator = teamMembers[random - 1];
    setFacilitator(facilitator);

    if (selectedActivity) {
      setFacilitationsDone([
        ...facilitationsDone,
        { id: `${facilitationsDone.length + 1}`, activity: selectedActivity, teamMember: facilitator }
      ]);
    }
  }

  const remove = (facilitation: Facilitation) => {
    setFacilitationsDone([
      ...facilitationsDone.filter(item => item.id !== facilitation.id),
    ]);
  }

  return (
    <LayoutWithTeamExistanceChecker>
      {activities.map(activitiy => {
        return (
          <div key={activitiy.id}>
            <label>
              <input
                name="activity"
                checked={selectedActivity && activitiy.id === selectedActivity.id}
                type="radio"
                value={activitiy.id}
                onChange={() => setSelectedActivity(activitiy)}
              />
              {activitiy.name}
            </label>
          </div>
        )
      })}

      {selectedActivity &&
        <div>
          <div className="flex">
            {teamMembers.map(member => {
              return <MemberCard key={member.id} member={member} />
            })}
          </div>
          <button onClick={pickFacilitator}>Pick one!</button>

          {selectdFacilitator && <MemberCard member={selectdFacilitator} />}
        </div>
      }

      <ul>
        {facilitationsDone.map(item => {
          return (
            <li key={item.id}>
              {item.teamMember.name} - {item.activity.name} <button onClick={() => remove(item)}>remove</button>
            </li>
          )
        })}
      </ul>
    </LayoutWithTeamExistanceChecker>
  )
}